import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState, useEffect } from 'react';
import { AISummariesStore } from './ai-summary-service/store';
import { AISummaryService } from './ai-summary-service';
import { useAnalyticsEvents } from '../../../common/analytics/generated/use-analytics-events';
import { failUfoExperience, startUfoExperience, succeedUfoExperience } from '../../analytics';
var EXPERIENCE_NAME = 'smart-link-ai-summary';
export var useAISummary = function useAISummary(props) {
  var _AISummariesStore$get;
  var url = props.url,
    baseUrl = props.baseUrl,
    headers = props.headers,
    product = props.product,
    ari = props.ari,
    envKey = props.envKey;
  var _useState = useState(((_AISummariesStore$get = AISummariesStore.get(url)) === null || _AISummariesStore$get === void 0 ? void 0 : _AISummariesStore$get.state) || {
      status: 'ready',
      content: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  var onStart = useCallback(function (id) {
    startUfoExperience(EXPERIENCE_NAME, id);
  }, []);
  var onSuccess = useCallback(function (id) {
    fireEvent('operational.summary.success', {});
    succeedUfoExperience(EXPERIENCE_NAME, id);
  }, [fireEvent]);
  var onError = useCallback(function (id, reason) {
    /**
     * Errors should only be counted to the SLO if they are not due to acceptable use violations
     * HIPAA content detected or exceeding context length.
     */

    var isSloError = reason === undefined ? true : !['ACCEPTABLE_USE_VIOLATIONS', 'HIPAA_CONTENT_DETECTED', 'EXCEEDING_CONTEXT_LENGTH_ERROR'].includes(reason);
    fireEvent('operational.summary.failed', {
      reason: reason || null,
      isSloError: isSloError
    });
    failUfoExperience(EXPERIENCE_NAME, id);
  }, [fireEvent]);
  useEffect(function () {
    var _AISummariesStore$get2;
    //do not create a service for the empty URL string when the link data is not yet available,
    //or the service has already been created and cached.
    if (url && !AISummariesStore.get(url)) {
      AISummariesStore.set(url, new AISummaryService({
        url: url,
        ari: ari,
        baseUrl: baseUrl,
        headers: headers,
        onError: onError,
        onStart: onStart,
        onSuccess: onSuccess,
        product: product,
        envKey: envKey
      }));
    }

    //returns function that calls unsubscribe method
    return (_AISummariesStore$get2 = AISummariesStore.get(url)) === null || _AISummariesStore$get2 === void 0 ? void 0 : _AISummariesStore$get2.subscribe(setState);
  }, [url, baseUrl, headers, onError, onStart, onSuccess, product, ari, envKey]);
  var summariseUrl = function summariseUrl() {
    var _AISummariesStore$get3;
    return (_AISummariesStore$get3 = AISummariesStore.get(url)) === null || _AISummariesStore$get3 === void 0 ? void 0 : _AISummariesStore$get3.summariseUrl();
  };
  return {
    summariseUrl: summariseUrl,
    state: state
  };
};